export type ItemIndexes = {[K: string]: number};

/* eslint no-param-reassign: 0 */
export function buildIndexMap<T extends string | number>(items: ReadonlyArray<T>): ItemIndexes {
  return items.reduce<ItemIndexes>((result, item, index) => {
    result[item] = index;
    return result;
  }, {});
}
